__turbopack_context__.v({
  "className": "proximanova_997f0eef-module__FcUloG__className",
  "variable": "proximanova_997f0eef-module__FcUloG__variable",
});
